<template>
  <div style="text-align: center;font-size: 0;">
    <img v-if="current == 1" src="@/assets/image/i-step1.png" />
    <img v-else-if="current == 2" src="@/assets/image/i-step2.png" />
    <img v-else-if="current == 3" src="@/assets/image/i-step3.png" />
  </div>
</template>

<script>
export default {
  name: "navStepList",
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
};
</script>
